import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { buildTableQueryString, IStoreState, ITableQueryParams } from "..";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { getSearchQuery } from "../common/helpers";
import { IQueryParams } from "../common/common.types";
import { ILedger, IMaterialOutward } from "./ledger.types";
import { server_base_endpoints } from "../../api/server-base-endpoints";

//=============================== Purchase Order List ===============================
export const FETCH_LEDGER_LIST_PROGRESS = "FETCH_LEDGER_LIST_PROGRESS";
export const FETCH_LEDGER_LIST_SUCCESS = "FETCH_LEDGER_LIST_SUCCESS";
export const FETCH_LEDGER_LIST_FAILED = "FETCH_LEDGER_LIST_FAILED";

export const fetchLedgerListProgress = () => action(FETCH_LEDGER_LIST_PROGRESS);
export const fetchLedgerListSuccess = (list: ILedger[], totalRecords: number) =>
  action(FETCH_LEDGER_LIST_SUCCESS, { list, totalRecords });
export const fetchLedgerListFailed = () => action(FETCH_LEDGER_LIST_FAILED);

export const fetchLedgerListAsync =
  (
    queryParams: ITableQueryParams,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      let searchQuery = buildTableQueryString(queryParams);
      dispatch(fetchLedgerListProgress());

      const res = await api.get(
        `${server_base_endpoints.ledger.get_ledger}${searchQuery}`,
      );
      const data: ILedger[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchLedgerListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchLedgerListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err?.response?.data?.message || "Unknown Error Occurred",
          displayAs: "snackbar",
        }),
      );
    }
  };

export const upsertMaterialOutwardAsync =
  (
    payload: IMaterialOutward,
    onCallback: (isSuccess: boolean, data?: IMaterialOutward) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());

      const { ...restPayload } = payload;
      const res = await api.post(
        server_base_endpoints.grn.upsert_material_outward,
        restPayload,
      );

      const responseData: IMaterialOutward = res.data.data;
      onCallback(true, responseData);
      dispatch(
        showMessage({
          type: "success",
          message: "Material Outward saved successfully!",
          displayAs: "snackbar",
        }),
      );
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

//=============================== Delete Single Purchase Order ===============================
export const deleteSinglePurchaseOrderAsync =
  (
    uuid: string,
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.delete("/purchase_order/delete-purchase-order", {
        data: { purchase_order_uuid: uuid },
      });
      dispatch(
        showMessage({
          type: "success",
          message: "Purchase Order deleted successfully!",
          displayAs: "snackbar",
        }),
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

//=============================== Clear State ===============================
export const CLEAR_SINGLE_LEDGER = "CLEAR_SINGLE_LEDGER";
export const CLEAR_LEDGER_STATE = "CLEAR_LEDGER_STATE";
export const clearLedgerSync = () => action(CLEAR_SINGLE_LEDGER);
export const clearLedgerStateSync = () => action(CLEAR_LEDGER_STATE);

// //#######################################################################################
// //############################ Purchase Order Analytics #################################
// //#######################################################################################
// export const FETCH_PURCHASE_ORDER_ANALYTICS_LIST_PROGRESS = "FETCH_PURCHASE_ORDER_ANALYTICS_LIST_PROGRESS";
// export const FETCH_PURCHASE_ORDER_ANALYTICS_LIST_SUCCESS = "FETCH_PURCHASE_ORDER_ANALYTICS_LIST_SUCCESS";
// export const FETCH_PURCHASE_ORDER_ANALYTICS_LIST_FAILED = "FETCH_PURCHASE_ORDER_ANALYTICS_LIST_FAILED";

// export const fetchPurchaseOrderAnalyticsListProgress = () =>
//   action(FETCH_PURCHASE_ORDER_ANALYTICS_LIST_PROGRESS);
// export const fetchPurchaseOrderAnalyticsListSuccess = (data: IAnalytics[]) =>
//   action(FETCH_PURCHASE_ORDER_ANALYTICS_LIST_SUCCESS, { data });
// export const fetchPurchaseOrderAnalyticsListFailed = () =>
//   action(FETCH_PURCHASE_ORDER_ANALYTICS_LIST_FAILED);

// export const fetchPurchaseOrderAnalyticsWithParamsAsync =(queryParams: {
//     from_data: string;
//     to_date: string;
//   }): ThunkAction<void, IStoreState, {}, AnyAction> =>
//     async (dispatch, getState) => {
//       try {
//         dispatch(fetchPurchaseOrderAnalyticsListProgress());
//         let finalUrl = `/analytics/get-purchase-order-analytics?from_date=${queryParams.from_data}&to_date=${queryParams.to_date}`;
//         const res = await api.get(finalUrl);
//         const data: IAnalytics[] = res.data.data;
//         dispatch(fetchPurchaseOrderAnalyticsListSuccess(data));
//       } catch (err: any) {
//         dispatch(fetchPurchaseOrderAnalyticsListFailed());
//         dispatch(
//           showMessage({
//             type: "error",
//             message: err.response.data.message,
//             displayAs: "snackbar",
//           }),
//         );
//       }
//     };

// export const CLEAR_PURCHASE_ORDER_ANALYTICS = "CLEAR_PURCHASE_ORDER_ANALYTICS";

// export const clearPurchaseOrderAnalyticsSync = () => action(CLEAR_PURCHASE_ORDER_ANALYTICS);

// ##########################################################################################
// ############################ Approval List#################################
// ##########################################################################################

export const FETCH_PURCHASE_ORDER_APPROVAL_LIST_PROGRESS =
  "FETCH_PURCHASE_ORDER_APPROVAL_LIST_PROGRESS";
export const FETCH_PURCHASE_ORDER_APPROVAL_LIST_SUCCESS =
  "FETCH_PURCHASE_ORDER_APPROVAL_LIST_SUCCESS";
export const FETCH_PURCHASE_ORDER_APPROVAL_LIST_FAILED =
  "FETCH_PURCHASE_ORDER_APPROVAL_LIST_FAILED";

export const fetchPurchaseOrderApprovalListProgress = () =>
  action(FETCH_PURCHASE_ORDER_APPROVAL_LIST_PROGRESS);
export const fetchPurchaseOrderApprovalListSuccess = (
  data: ILedger[],
  totalRecords: number,
) =>
  action(FETCH_PURCHASE_ORDER_APPROVAL_LIST_SUCCESS, {
    data,
    totalRecords,
  });
export const fetchPurchaseOrderApprovalListFailed = () =>
  action(FETCH_PURCHASE_ORDER_APPROVAL_LIST_FAILED);

export const fetchPurchaseOrderApprovalListAsync =
  (
    queryParams: IQueryParams,
    table_name: string,
    billing_company_uuid: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchPurchaseOrderApprovalListProgress());
      let searchQuery = getSearchQuery(queryParams);
      if (billing_company_uuid) {
        searchQuery += `&billing_company_uuid=${billing_company_uuid}`;
      }
      let finalUrl = `/approval/get-approval${searchQuery}&table_name=${table_name}`;
      const res = await api.get(finalUrl);
      const data: ILedger[] = res.data.data;
      dispatch(
        fetchPurchaseOrderApprovalListSuccess(data, res.data.totalRecords),
      );
    } catch (err: any) {
      dispatch(fetchPurchaseOrderApprovalListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };
